let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lyamL")).then(() => parcelRequire('4idZl'));